const NAME = "PAYROLL_TYPES_SETTINGS";

export default NAME;
